import { useEffect, useState } from "react";

/* Whether the viewport is at or above a breakpoint. */
export const useIsWide = (query = "(min-width: 1024px)") => {
  const [isWide, setIsWide] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return true;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const list = window.matchMedia(query);
    const onChange = (event) => setIsWide(event.matches);
    setIsWide(list.matches);

    /* addEventListener is the modern API; addListener is Safari before 14 and
       the only one some jsdom shims provide. */
    if (list.addEventListener) {
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    }
    list.addListener(onChange);
    return () => list.removeListener(onChange);
  }, [query]);

  return isWide;
};

export default useIsWide;
